import { Classification, Relevance } from '@/types';

export const RelevanceOptions = {
  relevant: {
    value: Relevance.Relevant,
    label: 'Yes',
  },
  notRelevant: {
    value: Relevance.NotRelevant,
    label: 'No',
  },
  maybeRelevant: {
    value: Relevance.MaybeRelevant,
    label: 'Maybe',
  },
};

export const ClassificationOptions = {
  primary: {
    value: Classification.Primary,
    label: 'Primary',
  },
  secondary: {
    value: Classification.Secondary,
    label: 'Secondary',
  },
  future: {
    value: Classification.Future,
    label: 'Future',
  },
  litigation: {
    value: Classification.Litigation,
    label: 'Litigation',
  },
};

export const FilterOptions = {
  relevance: Object.values(RelevanceOptions),
  classification: Object.values(ClassificationOptions),
};
